import { brazeLogCustomEvent } from '@ecomm/braze/brazeLogCustomEvent'
import { getBraze } from '@ecomm/shared-window'
import type { BrazeVariationEnteredEvent } from '@ecomm/tracking-types/BrazeVariationEnteredEvent'

export const sendNinetailedExperimentVariationsData = (
  experimentsData: readonly BrazeVariationEnteredEvent[]
) =>
  !!getBraze(braze => {
    experimentsData.forEach(e => {
      brazeLogCustomEvent('Variation_entered', e)
    })
    braze.requestImmediateDataFlush()
    return true
  })
